import script from "./EventForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EventForm.vue?vue&type=script&setup=true&lang=js"

import "./EventForm.vue?vue&type=style&index=0&id=0ad8b9d1&scoped=true&lang=css"

import exportComponent from "C:\\wisata-jepara-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad8b9d1"]])

export default __exports__